import { Component, Inject, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { MAT_DIALOG_DATA } from '@angular/material';
import { DatabaseService } from 'src/_services/DatabaseService';
import { ToastrManager } from 'ng6-toastr-notifications';


@Component({
  selector: 'app-header-setting-modal',
  templateUrl: './header-setting-modal.component.html'
})
export class HeaderSettingModalComponent implements OnInit {
  data: any = {};
  skLoading: boolean = false;
  todo = [];
  done = [];

  constructor(@Inject(MAT_DIALOG_DATA) public modalData, public service: DatabaseService, public toast: ToastrManager) {
    this.data.table_type = 'sfa_user';
    this.getHeader(this.data.table_type);
  }

  ngOnInit() {
  }





  refresh() {
    this.todo = [];
    this.done = [];

  }



  getHeader(type) {
    this.skLoading = true;
    let payload
    if (type == 'sfa_user') {
      payload = 'sfa_user,sfa_asm_assign'
    }
    else {
      payload = 'sfa_dr'
    }
    this.service.post_rqst({ 'table_name': payload }, "Reports/fetchHeader").subscribe((result) => {
      if (result['statusCode'] == 200) {
        for (let i = 0; i < result['result'].length; i++) {
          if (result['result'][i]['flag'] == 0) {
            this.todo.push({ 'id': result['result'][i]['id'], 'header_name': result['result'][i]['header_name'], 'show_name': result['result'][i]['show_name'], })
          }
          else {
            this.done.push({ 'id': result['result'][i]['id'], 'header_name': result['result'][i]['header_name'], 'show_name': result['result'][i]['show_name'], })
          }
        }
        this.skLoading = false;
      } else {
        this.skLoading = false;
        this.toast.errorToastr(result['statusMsg'])
      }
    });
  }

  saveHeader() {
    this.skLoading = true;
    let payload
    if (this.data.table_type == 'sfa_user') {
      payload = 'sfa_user,sfa_asm_assign'
    }
    else {
      payload = 'sfa_dr'
    }

    this.service.post_rqst({ 'selected_headers': this.done, 'table_name': payload }, "Reports/storeHeaders").subscribe((result) => {
      if (result['statusCode'] == 200) {
        this.toast.successToastr(result['statusMsg']);
        this.skLoading = false;
      } else {
        this.skLoading = false;
        this.toast.errorToastr(result['statusMsg'])
      }
    });
  }



  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

}
